// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Diamond20 from './Diamond20';
import Diamond20Filled from './Diamond20Filled';
import Diamond20Circle from './Diamond20Circle';
import Diamond24 from './Diamond24';
import Diamond24Filled from './Diamond24Filled';
import Diamond24Circle from './Diamond24Circle';
import Diamond40 from './Diamond40';
import Diamond40Filled from './Diamond40Filled';
import Diamond48 from './Diamond48';
import Diamond48Filled from './Diamond48Filled';

type DiamondProps = {
    variation:
        | '20'
        | '20Filled'
        | '20Circle'
        | '24'
        | '24Filled'
        | '24Circle'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Diamond20,
    Diamond20Filled,
    Diamond20Circle,
    Diamond24,
    Diamond24Filled,
    Diamond24Circle,
    Diamond40,
    Diamond40Filled,
    Diamond48,
    Diamond48Filled,
};

const Diamond: FC<DiamondProps> = ({ variation, ...props }) => {
    const variationKey = `Diamond${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Diamond" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Diamond;
